import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { Fragment, useEffect, useState } from 'react';

export const RevenuePerSportsGraph = ({ data }: any) => {
  const [chartOptions, setChartOptions] = useState({});

  useEffect(() => {
    const sports = data?.items.map((item: any) => item?.Name || 'N/A');
    const bookingData = data?.items.map((item: any) => item?.BookingValue ?? 0);
    const revenueData = data?.items.map((item: any) => item?.RevenueValue ?? 0);

    const colors = ['#35B1E8', '#FFA51F'];

    setChartOptions({
      chart: {
        type: 'column',
      },
      title: {
        text: 'Revenue per Sport',
        style: {
          fontSize: '14px',
        },
      },
      xAxis: {
        categories: sports,
        crosshair: true,
        title: {
          text: '● Sports',
          style: {
            fontSize: '11px',
          },
        },
        labels: {
          style: {
            fontSize: '11px',
          },
        },
      },
      yAxis: {
        min: 0,
        // max: 500, // Optional: set a max value if your data range is known
        // tickInterval: 100, // Force ticks at intervals of 100
        title: {
          text: 'Total Bookings',
        },
        labels: {
          formatter: function (this: any) {
            return this.value; // This avoids formatting like "10k"
          },
          style: {
            fontSize: '11px',
          },
        },
      },
      tooltip: {
        shared: true,
        useHTML: true,
        formatter: function (this: any) {
          const index = this.points?.[0]?.point.index ?? 0;

          return `
            <b>${sports[index]}</b><br/>
            <span style="color:${colors[0]}">●</span>  Booking: <b>${bookingData[index]}</b><br/>
            <span style="color:${colors[1]}">●</span>  Revenue: <b>KD ${revenueData[index]}</b><br/>
          `;
        },
      },
      plotOptions: {
        column: {
          pointPadding: 0.2,
          borderWidth: 0,
        },
      },
      credits: {
        enabled: false,
      },
      series: [
        {
          name: 'Booking',
          data: bookingData,
          color: colors[0],
        },
        {
          name: 'Revenue',
          data: revenueData,
          color: colors[1],
        },
      ],
    });
  }, [data]);

  return (
    <Fragment>
      <HighchartsReact highcharts={Highcharts} options={chartOptions} />
    </Fragment>
  );
};
